import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import WarningIcon from '@material-ui/icons/Warning';
import classnames from 'classnames';
import React from 'react';
import { Loading } from 'react-admin';
import { campType, formatAdresse } from '../references';


//28B463
const useStyles = makeStyles({
    container: { minWidth: '45em',borderWidth: 0.0001, borderStyle: 'inset',borderColor:'#D1D1D1' },
    rightAlignedCell: { textAlign: 'right' },
    centerAlignedCell: { textAlign: 'center' },
    leftAlignedCell: { textAlign: 'left' },
    boldCell: { fontWeight: 'bold', textAlign: 'left' },
    total_general: { fontWeight: 'bold', textAlign: 'center' },
    separateur: { backgroundColor: '#E5E7E9' },
    margin0: { marginLeft: 2, padding: 1, fontSize: 10 },
    legend: { color: '#9E9BA1', marginTop:5,marginBottom:5,marginLeft:0,marginRight:0,padding:0, fontSize: 10 },
    marginAgent: { marginLeft: 280 },
    numFact: { padding: 0, margin: 0, color: '#fb8500', fontWeight: 'bold' },
    dateFact: { marginLeft: 302 },
    padding: { padding: 0, margin: 0 },
    bold: { fontWeight: 'bold', padding: 0, margin: 0 },
    color_client: { color: '#7209b7', fontWeight: 'bold', padding: 0, margin: 0 },
    //text_decoration: { textDecoration: 'none', color: 'inherit' },
    gratuit: { color: '#9E9BA1', marginLeft: 10, paddingBottom: 0, marginBottom: 0, marginTop: 2, fontSize: 14 },
    enteteFactureSociete: { width: '50%' },
    enteteFactureAgent: { width: '35%' },
    enteteFactureLogo: { width: '15%', textAlign: 'center' },
    rib: { fontSize: 10 },
    //tableBorder : { borderWidth: 0.0001, borderStyle: 'inset',borderColor:'#D3D3D3'}, // or borderTop: '1px solid red'
    warning:{color:'#fb8500',margin:0,padding:0,paddingLeft:20}


});


const InvoiceDetails = (facture) => {

    const classes = useStyles();

    const record = facture.facture;

    if (!record && !record.order && !record.order.client_exp) return <Loading/>;

    return (
        <Paper className={classes.container} elevation={10}>
            <Table >
                <TableBody>
                    <TableRow >
                        <TableCell >
                            <p className={classes.bold}>TLDI Logistique Services</p>
                            <p className={classes.padding}>54 Rue DE CLIGNANCOURT 75018 PARIS</p>
                            <p className={classes.padding}>Tel : +33699000649</p>
                            <p className={classes.padding}>Tel : +33973648929</p>
                            <p className={classes.padding}>Email : contact@tldilogistique.com</p>
                            <p className={classes.padding}>Siret : 888 332 244 R.C.S PARIS</p>
                            <p className={classes.padding}>IBAN : FR51 3000 2004 3900 0037 5767 Z61</p>
                            <p className={classes.padding}>BIC : CRLYFRPP</p>
                        </TableCell>
                        <TableCell className={classes.leftAlignedCell}>
                            <p className={classes.bold}>Agent : {record.orderDetails.fullname}</p>
                            <p className={classes.numFact}>N° facture : {record.order.ancien_code===null ? record.order.code:record.order.code+'/'+record.order.ancien_code}</p>
                            
                            <p className={classes.padding}>Type campagne : {campType(record.order.campType)}</p>
                            <p className={classes.padding}>Date facture : {record.orderDetails.createdDate}</p>
                            <p className={classes.padding}>Arrivée pévue : {record.order.campagne.dateArrive}</p>
                            <p className={classes.padding}>Tel : +224660267474</p>
                            <p className={classes.padding}>Tel : +224666950151</p>
                            <p className={classes.padding}>Tel : +224628130578</p>

                        </TableCell>
                        <TableCell className={classes.rightAlignedCell}>
                            <div>
                                <img src="images/tldi_logo.jpg" title="TLDI Logistique" alt="TLDI Logistique Services" width="140" height="90" />
                            </div>
                        </TableCell>
                    </TableRow>
                    <TableRow key="exp_dest">

                        <TableCell className={classes.enteteFactureSociete}>
                            <p className={classes.bold}>Expéditaire</p>
                            <p className={classes.padding}>{record.order.client_exp.fullname}</p>
                            <p className={classes.padding}>Tel : <a href={"tel:" + record.order.client_exp.telephone1}>{record.order.client_exp.telephone1}</a></p>
                            <p className={classes.padding}>{record.order.client_exp.adresse ? 'Adresse : ' + formatAdresse(record.order.client_exp.adresse) : ''}</p>
                        </TableCell>
                        <TableCell className={classes.enteteFactureAgent}>
                            <p className={classes.bold}>Destinataire</p>
                            <p className={classes.padding}>{record.order.client_dest.fullname}</p>
                            <p className={classes.padding}>Tel : <a href={"tel:" + record.order.client_dest.telephone1}>{record.order.client_dest.telephone1}</a></p>
                            <p className={classes.padding}>{record.order.client_dest.adresse ? 'Adresse : ' + formatAdresse(record.order.client_dest.adresse) : ''}</p>
                        </TableCell>

                        <TableCell className={classes.enteteFactureLogo}>
                            {record.orderLineStat.reste_a_payer ?
                                <span>
                                    <p className={classes.bold}><i>Reste à payé : {record.orderLineStat.reste_a_payer}€</i></p>
                                    <p>Vous avez payé : {record.orderLineStat.total_encaisse}€</p>
                                    {record.orderLineStat.total_encaisse ? <p>Par : {record.orderDetails.mode_payements}</p>:null}

                                </span>
                                :
                                <div>
                                    <img src="images/paye.png" title="TLDI Logistique" alt="TLDI Logistique Services" width="100" height="40" />
                                    <p>Par : {record.orderDetails.mode_payements}</p>
                                </div>
                            }
                        </TableCell>

                    </TableRow>
                </TableBody>
            </Table>


            <Table >
                <TableHead>
                    <TableRow className={classes.separateur} key="titre" >
                        <TableCell>N°</TableCell>
                        <TableCell className={classes.leftAlignedCell}>Description</TableCell>
                        <TableCell className={classes.centerAlignedCell}>Quantite</TableCell>
                        <TableCell className={classes.centerAlignedCell}>Poids(kg)</TableCell>
                        <TableCell className={classes.centerAlignedCell}>Prix unitaire HT(€)</TableCell>
                        <TableCell className={classes.centerAlignedCell}>Prix total HT(€)</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody >
                    {record.orderLinesList.map(item =>
                    (
                        <TableRow key={item.id}>
                            <TableCell>{item.seq}</TableCell>
                            <TableCell className={classes.leftAlignedCell}>{item.description}</TableCell>
                            <TableCell className={classes.centerAlignedCell}>{item.quantite}</TableCell>
                            <TableCell className={classes.centerAlignedCell}>{item.poids}</TableCell>
                            <TableCell className={classes.centerAlignedCell}>{item.prix_unitaire}</TableCell>
                            <TableCell className={classes.centerAlignedCell}>{item.total_line}</TableCell>
                        </TableRow>
                    )
                    )}
                    <TableRow className={classes.separateur} key="separateur"><TableCell colSpan={2} /><TableCell colSpan={2} ></TableCell><TableCell colSpan={2} /></TableRow>

                    <TableRow key="total_prix">
                        <TableCell colSpan={4} />
                        <TableCell className={classes.leftAlignedCell}>
                            Total HT
                        </TableCell>
                        <TableCell className={classes.centerAlignedCell}>
                            {record.orderLineStat.total} €
                        </TableCell>
                    </TableRow>

                    {record.order.frais_enlevement ?
                        <TableRow key="frais_enle">
                            <TableCell colSpan={4} />
                            <TableCell className={classes.leftAlignedCell}>
                                Frais enlèvement
                        </TableCell>
                            <TableCell className={classes.centerAlignedCell}>{record.order.frais_enlevement} €</TableCell>
                        </TableRow> : null
                    }

                    <TableRow key="tva">
                        <TableCell colSpan={4} />
                        <TableCell className={classes.leftAlignedCell}>
                            TVA
                        </TableCell>
                        <TableCell className={classes.centerAlignedCell}>
                            0 %
                        </TableCell>
                    </TableRow>
                    {record.orderLineStat.reduction && !record.order.gratuit_excep ?
                        <TableRow key="gratuit">
                            <TableCell colSpan={4} />
                            <TableCell className={classes.leftAlignedCell}>
                                Réduction
                        </TableCell>
                            <TableCell className={classes.centerAlignedCell}>{record.orderLineStat.reduction} € ({record.orderLineStat.prourc_reduct}%)</TableCell>
                        </TableRow> : null
                    }

                    <TableRow key="ttc">
                        <TableCell colSpan={4} />
                        <TableCell className={classes.boldCell} >
                            Total TTC
                        </TableCell>
                        <TableCell
                            className={classnames(

                                classes.total_general
                            )}
                        >

                            {record.orderLineStat.total_general} €

                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            { record.order.gratuit_excep ?
                <TableRow key="message_gratuit">
                    <TableCell >
                    <legend className={classes.gratuit}><i>
                        TLDI Logistique Services et toute l'équipe vous envoie gratuitement ce colis !
                        </i> </legend>
                        </TableCell>
                </TableRow> : null
            }
            <Table >
                <TableBody>
                    <TableRow key="legend">
                        <TableCell className={classes.warning} >
                        
                        <WarningIcon/>
                        
                        </TableCell>    
                        <TableCell >
                        
                            <legend className={classes.legend}><i>
                                Tout article interdit, illégal ou frauduleux est à votre responsablité, tout article non déclaré n'est pas remboursable.
                                Tout colis non réclamé après une semaine vous expose à des frais de magasinage. Nous comptons sur votre compréhension.
                                </i> 
                            </legend>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
       
        </Paper>
    );
};

export default InvoiceDetails;
